import React from 'react';
import { connect } from 'react-redux';

import { StoreState } from '../../../../redux/reducers/store.types';
import { MediaAsset } from '../../../../types/media-assets';
import { MaybeUndef } from '../../../../types/system';
import { Thumb } from '../../../file-manager/files-list/thumb/thumb';

import { getMediaAssetById } from './thumb-by-file-id.selectors';

export interface OwnProps {
  fileId: string;
}

interface StateProps {
  mediaAsset: MaybeUndef<MediaAsset>;
}

type Props = StateProps & OwnProps;

export const ThumbOrNull: React.FunctionComponent<Props> = ({
  mediaAsset,
}: Props) => {
  if (!mediaAsset) {
    return null;
  }

  return <Thumb mediaAsset={mediaAsset} />;
};

export const ThumbByFileIdContainer = connect<StateProps, void, OwnProps>(
  (state: StoreState, ownProps: OwnProps) => ({
    mediaAsset: getMediaAssetById(state, ownProps),
  }),
)(ThumbOrNull);
